module.exports = __webpack_public_path__ + "static/media/3.18786159.JPG";